/**
 * Main blog section – custom behavior (if needed).
 * Loaded on blog template when main-blog section is present.
 */
(function () {
  'use strict';
  // Reserved for future main-blog custom JS (e.g. category nav enhancements).
})();
